import { render, staticRenderFns } from "./dashboardview.vue?vue&type=template&id=70e7d68d&"
import script from "./dashboardview.vue?vue&type=script&lang=js&"
export * from "./dashboardview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports